"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETransferType = void 0;
var ETransferType;
(function (ETransferType) {
    ETransferType[ETransferType["DEFAULT"] = 0] = "DEFAULT";
    ETransferType[ETransferType["DEBT"] = 1] = "DEBT";
    ETransferType[ETransferType["RETURN_DEBT"] = 2] = "RETURN_DEBT";
    ETransferType[ETransferType["CONFISCATE_DEBT"] = 3] = "CONFISCATE_DEBT";
    ETransferType[ETransferType["TAKE"] = 4] = "TAKE";
    ETransferType[ETransferType["SPEND"] = 5] = "SPEND";
    ETransferType[ETransferType["PLEDGE"] = 6] = "PLEDGE";
    ETransferType[ETransferType["RETURN_PLEDGE"] = 7] = "RETURN_PLEDGE"; // вернуть залог
})(ETransferType = exports.ETransferType || (exports.ETransferType = {}));
